var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.5 13.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m6.85,13.4c-1.95-.03-3.9-.16-5.84-.39-.13-.02-.26-.03-.37-.1-.15-.09-.23-.27-.3-.43-.6-1.59-.26-3.35-.15-5.05.13-2-.08-4.02.2-6.01.03-.22.07-.45.19-.65C.89.27,1.58.21,2.18.22c1.55.02,3.15.17,4.7.42.58.1.52,1.14.16,1.5-.13.13-.39.1-.57.11-.45.01-.91-.04-1.36-.03-.77.02-1.54.04-2.31.11-.13.01-.27.03-.34.14-.03.05-.04.12-.05.18-.25,2.21-.41,4.43-.49,6.66,0,.25-.01.52.1.75.14.29.44.46.73.59.52.23,1.07.37,1.64.42.87.07,1.73-.08,2.6-.09.61,0,1.22.05,1.83.14.28.04.61.07.82-.13.12-.11.18-.28.2-.45.11-.67-.15-1.35-.03-2.02.04-.2.12-.41.31-.49.12-.05.25-.04.38-.03.25.02.5.05.75.07.2.02.42.04.57.17.23.18.28.51.3.81.11,1.23.22,2.46.32,3.69.01.13.02.27-.06.38-.09.11-.25.13-.4.15-1.71.13-3.42.18-5.13.15Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.27,4.27s0,0,0,0c-.01,0-.03,0-.04.01-.42.24-3.89,2.95-4.19,3.31-.2.23-.41.45-.63.65-.16.15-.4.44-.63.48-.07.02-.15.05-.21.09-.12.07-.24.06-.37,0-.26-.11-.53-.16-.77-.31-.06-.03-.11-.07-.14-.13-.07-.14-.03-.4-.04-.56-.02-.29.09-.51.34-.69.29-.21,4.68-3.57,4.95-3.81.21-.19.23-.35.03-.57-.35-.4-.65-1.08-.41-1.57.03-.06.06-.12.11-.17.04-.03.08-.05.12-.07.33-.14.7-.3,1.06-.32.48-.02.92-.24,1.4-.3C12.49.23,13.13.03,13.77,0c.42-.02.66.17.71.59.05.44.03.87-.16,1.28-.28.63-.46,1.29-.72,1.92-.17.42-.49,1.49-1.06,1.36-.27-.06-.6-.07-.82-.26-.19-.16-.25-.42-.42-.6,0-.01-.02-.02-.03-.02Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/External.65f08672ce954ce7d3ad5f49a2603ff0.svg";
export { ForwardRef as ReactComponent };